import script from "./AIChatView.vue?vue&type=script&setup=true&lang=js"
export * from "./AIChatView.vue?vue&type=script&setup=true&lang=js"

import "./AIChatView.vue?vue&type=style&index=0&id=0b899095&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b899095"]])

export default __exports__